const PropTypes = require('prop-types');
const React = require('react');

class AddressBox extends React.Component {
  displayExtendedAddress() {
    if (this.props.extendedAddress === '') {
      return <br />;
    }
    return <div>{this.props.extendedAddress}</div>;
  }

  render() {
    return (
      <div>
        <div className="big strong">
          {this.props.name}
        </div>
        {this.props.streetAddress}
        {this.displayExtendedAddress()}
        {this.props.locality}, {this.props.region} {this.props.postalCode}
        <br />
        {this.props.countryCode}
        <br />
        {this.props.phone}
        <a
          id="edit_address"
          data-edit-address-id={this.props.addressId}
          className="boxed-list__action"
          onClick={this.props.nowEditing}
        >
          <i className="fa fa-pencil"></i> {I18n.t('js.addresses.addressBox.edit')}
        </a>
      </div>
    );
  }
}

AddressBox.propTypes = {
  name: PropTypes.string,
  streetAddress: PropTypes.string,
  extendedAddress: PropTypes.string,
  locality: PropTypes.string,
  region: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string,
  phone: PropTypes.string,
  nowEditing: PropTypes.func.isRequired,
  addressId: PropTypes.string,
};

module.exports = AddressBox;



// WEBPACK FOOTER //
// ./javascripts/components/addresses/address_box.jsx